var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('div',{staticClass:"overflow-y-auto pa-0 ma-0 mx-auto fill-height",style:({paddingBottom: _vm.noBottom ? '0 !important' : '4.375rem !important'})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }